export const GET_VENTAS_CLIENTE_START = 'GET_VENTAS_CLIENTE_START';
export const GET_VENTAS_CLIENTE_ERROR = 'GET_VENTAS_CLIENTE_ERROR';
export const GET_VENTAS_CLIENTE_SUCCESS = 'GET_VENTAS_CLIENTE_SUCCESS';

export const SET_FILTER_PARAMS = 'SET_FILTER_PARAMS';

export const RESET_VENTAS_CLIENTE_STATE = 'RESET_VENTAS_CLIENTE_STATE';